function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  id: "a",
  d: "M8.968 24.184V10.58a4.5 4.5 0 0 1 4.5-4.5H37.49a4.5 4.5 0 0 1 4.5 4.5V28.64a4.5 4.5 0 0 1-4.5 4.5H26.873C26.085 38.161 21.74 42 16.5 42 10.701 42 6 37.299 6 31.5c0-2.845 1.131-5.425 2.968-7.316zm3-2.158A10.459 10.459 0 0 1 16.5 21c5.338 0 9.746 3.984 10.413 9.141H37.49a1.5 1.5 0 0 0 1.5-1.5V10.58a1.5 1.5 0 0 0-1.5-1.5H31.5v5.42a.5.5 0 0 1-.5.5H20a.5.5 0 0 1-.5-.5V9.08h-6.032a1.5 1.5 0 0 0-1.5 1.5v11.446zM28.5 9.08h-6V12h6V9.08zM16.5 39a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15zm15-12a1.5 1.5 0 0 1 0-3h3a1.5 1.5 0 0 1 0 3h-3zm-12.96 1.745l-1.955 2.6 1.988 2.958c.364.54.148 1.233-.482 1.545-.63.313-1.435.127-1.798-.414l-2.595-3.86a.5.5 0 0 1 .016-.58l2.613-3.476c.394-.525 1.21-.676 1.82-.337.611.339.787 1.04.392 1.564z"
});

var SvgShipmentReturn = function SvgShipmentReturn(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref);
};

export default SvgShipmentReturn;


//////////////////
// WEBPACK FOOTER
// ./src/icons/shipment-status/shipment-return.svg
// module id = 184
// module chunks = 0 1